import CapTableForm from './CapTableForm';

export default CapTableForm;
